'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Analytics from '../../utils/Analytics';

import './ProfileChangeModal.scss';

export default class ProfileChangeModal extends Component {
    static propTypes = {
        reasons: PropTypes.array,
        onRefreshMealFeed: PropTypes.func.isRequired,
        onKeepMeals: PropTypes.func.isRequired,
    };

    static defaultProps = {
        reasons: [],
    };

    onRefreshMealFeed = async () => {
        const { onRefreshMealFeed, reasons } = this.props;
        
        // Fire analytics before closing the modal
        Analytics.changeMeals({ Reasons: reasons });
        
        try {
            await onRefreshMealFeed();
            Analytics.changeMealsCompleted({ Reasons: reasons });
        } catch (error) {
            Analytics.changeMealsError({ Reasons: reasons, Error: error?.message || error });
        }
    }

    onClickCancel = () => {
        const { onKeepMeals, reasons } = this.props;
        
        // Fire analytics and call the parent handler
        Analytics.keepMeals({ Reasons: reasons });
        onKeepMeals();
    }

    render = () => {
        return (
            <Modal isOpen={true}
                onRequestClose={this.onClickCancel}
                closeModal={this.onClickCancel}
                contentLabel="Profile doesn't match Meal Plan"
                className="preferences-mismatch-modal"
                overlayClassName="feed-modal-overlay"
                closeTimeoutMS={250}>

                <div className="preferences-mismatch-modal-container">
                    <h1>Your preferences have been changed.</h1>
                    <h2>You're about to change the meals you have already planned.</h2>
                    <p>Do you want to change your meal selections to reflect your new preferences or keep them as planned? You can't undo this action.</p>

                    <footer className="prefs-dropdown-footer">
                        <button className="ok-btn" onClick={this.onRefreshMealFeed}>CHANGE MY MEALS</button>
                        <button className="cancel-btn" onClick={this.onClickCancel}>KEEP MY MEALS AS PLANNED</button>
                    </footer>
                </div>
            </Modal>
        );
    }
}